export default __webpack_public_path__ + "assets/images/file-icon-9824ec28.svg";